Namespace 'Surveys'
class Surveys.SurveyStatsView extends Backbone.View
  template: JST['backbone/templates/monitoring/survey_stats']

  initialize: (@options = {}) ->
    @surveyName = @options.surveyName
    @requests = @options.stats.requests
    @responses = @options.stats.responses
    @responsePercentage = @options.stats.percentage

  render: ->
    @$el.html @template
      requests: @requests
      responses: @responses
      surveyName: @surveyName
    @$el.find('.modal').modal()
    @chart = new Highcharts.Chart(@_chartOptions(@responsePercentage))
    @

  _chartOptions: (data) ->
    options = {
      chart:
        type: 'solidgauge'
        renderTo: @$el.find('.stats-chart')[0]
        style:
          fontFamily: ['Roboto', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif']
      title: null
      exporting: false
      pane:
        startAngle: -90
        endAngle: 90
        size: '180%'
        center: ['50%', '90%']
        background:
          backgroundColor: '#d1d1d1'
          innerRadius: '85%'
          outerRadius: '100%'
          shape: 'arc'
      tooltip:
        enabled: false
      yAxis:
        min: 0
        max: 100
        lineWidth: 0
        minorTickInterval: null
        tickAmount: 0
        labels:
          y: 20
          align: 'center'
          distance: -10
          format: '{value}%'
          style:
            fontSize: '16px'
            color: '#9e9e9e'
      plotOptions:
        solidgauge:
          color: '#47bf78'
          innerRadius: '85%'
          dataLabels:
            y: -100
            borderWidth: 0
            useHTML: true
      series: [{
        data: [{
          color: '#47bf78',
          y: data
        }]
        color: '#47bf78',
        dataLabels:
          format: '<div class="text-center"><span class="survey-stats-percentage">{y}%</span><br/>'
          y: 0
      }]
    }
